var xhr, scheduled = false, _throttleDelay = 200, $body, $modal, $secondaryModal,$window;
var timeout = false;
var delta = 200;
var subnavOrigin = 0;
var body = document.querySelector("body");
var $header;
var $header_is_fixed = false;  


$(function(){	
	"use strict";
    $body   = $('body');
    $window = $(window);
    $header = $('header');
        
    if ("ontouchstart" in window || navigator.msMaxTouchPoints) {
        $body.addClass('touch');
    } else {
        $body.addClass('no-touch');    
        if($('.skrollr').length>0){
            var s = skrollr.init();    
        } 
    }
    $('.select2').select2();
    $body.addClass('loaded');


    $('.burger').click(function(){
        if($body.hasClass('menu-open')){
            $body.removeClass('menu-open');            
        }else{
            $body.addClass('menu-open');
        }
        return false;
    });    

    $('.sidebar-menu .first__child > div').click(function(){
         $(this).parent().toggleClass('hidden-sub');
    });

  
    $('.popup-overlay').click(function(){
        if($('body').hasClass('menu-open')){
            $('.sidebar-menu .animate-delay').each(function(){
                $(this).addClass('no-delay').addClass('no-delay');
            });
            $('body.menu-open').removeClass('menu-open');

            console.log($('body.menu-open'));
            setTimeout(function(){
                $('.sidebar-menu .animate-delay').each(function(){
                    $(this).removeClass('no-delay').removeClass('no-delay');
                });    
            },200);
            
            if($('body').hasClass('open-search')){
                $('input').addClass('no-animate');
                $('body').removeClass('open-search');
                $('.active-search').removeClass('active-search');
                setTimeout(function(){
                    $('input').removeClass('no-animate');    
                },200);
            }    
        }
        return false;
    });


    initWayPoints();

    $.cookieBar({
        element: 'body',
        zindex: '999999',
        message: COOKIE_NOTICE,
        acceptText: COOKIE_ACCEPT,
        policyText: COOKIE_PRIVACY,
        policyURL: COOKIE_URL,
        bottom: true,
        domain: 'www.olympicmarine.gr',
        referrer: 'www.olympicmarine.gr'
    });

    $(".fancybox").fancybox();
    
	callbacks();
	
    var keydown_timeout;    


    $(document).on('click', '.scroll-to-element',function (e) {
        scroll2element($(this).attr('href'));
        e.preventDefault();
    });

    $('.scroll-down').click(function(e){
        $("html, body").animate({ scrollTop: $('#hero_section').innerHeight() }, 500);    
        e.preventDefault();
    });

    $(document).on('click', '#cookie-bar a.cb-enable', function (e) {
        $('#cookie-bar').addClass('r-loc');
    });

    $(document).on("click", ".load-more", function () {
        var target = $(this).data('target');
        more(target);
        return false;
    });


    $(document).on('click', '[data-action="submit"]', function () {
        var target = $(this).data('target');
        $(target).submit();
        return false;
    });
	
    $(".footer__back-to-top").click(function(){
        $("html,body").animate({scrollTop: 0 },"1000");
        return false;
    });  

    $(document).on('click', ".modal-btn", function (e) {
        try{
            e.preventDefault();         
           if($(this).attr("href")){
                openAjaxModal($(this).attr('href'), $('#'+ $(this).data('modal')));             
            }else{
                openAjaxModal($(this).data('href'), $('#'+ $(this).data('modal')));             
            }   
        }catch(Error){
            console.log(Error);
        }
        return false;
    });
    scrollEvents();
    $('.datepicker').each(function(){
        $(this).datetimepicker();
    })
    
   
});

function initShares(){
    "use strict";
    $('#ajaxModal').on('hidden.bs.modal', function () {
        if($('#ajaxModalFull').hasClass('in')){
            $('body').addClass('modal-open');
        }
    });
    
    
    var clipboard = new Clipboard('.clipboardButton');
    clipboard.on('success', function(e) {
        console.info('Action:', e.action);
        console.info('Text:', e.text);
        console.info('Trigger:', e.trigger);
        
        $('.clipboardButton .copy-label').text(' copied!');
        
        e.clearSelection();
    });
    clipboard.on('error', function(e) {
        console.error('Action:', e.action);
        console.error('Trigger:', e.trigger);
        
    }); 
}

function filterNews(){
    $('.filter.nav-link').click(function(){
        $('.filter.nav-link').removeClass('active');
        $(this).addClass('active');
        var target =  $(this).data('target');
        var value = $(this).data('value');
        var filter_name = $(this).data('filterName');
        $('form[name="' + target + '-nav"] input[name="'+filter_name+'"]').val(value);
        $('form[name="' + target + '-nav"] input[name="page"]').val(0);
        
        $.ajax({data: $('form[name="' + target + '-nav"]').serialize(), dataType: 'html', success: function (result) {

           

            $('.' + target + '-list').html(result);

            var updatePages =  updateNumPages(target);
          

        }
        });
    }); 
}


function updateNumPages(target){
    $.ajax({
        data:$('form[name="'+target+'-nav"]').serialize() + "&numpages=true",
        dataType:'html',
        success:function(data){
             $('form[name="'+target+'-nav"] input[name="num_pages"]').val(data);    

               var current_page = Number($('form[name="' + target + '-nav"] input[name="page"]').val()+1);
                var total_page =  Number($('form[name="' + target + '-nav"] input[name="num_pages"]').val());
               
                if( current_page>=total_page ){
                    $('.load-more[data-target="'+target+'"]').hide();
                    
                }else{
                      $('.load-more[data-target="'+target+'"]').show();
                }        
        }
    });
}


function initWayPoints(){   
    var ua = navigator.userAgent.toLowerCase(); 
    if (ua.indexOf('safari') != -1) { 
      if (ua.indexOf('chrome') > -1) {
        var  $safari = false;
      } else {
        var  $safari = true;
      }
    }
    if($safari ){
        $('.way-point-animate').addClass('shown') ;
    }else{
        if( $('.way-point-animate').not( ".way-point-ready").length>0 ){
            $('.way-point-animate').addClass( "way-point-ready");

            $('.way-point-animate').waypoint(function(direction) {
                if(  $(this.element).hasClass('shown')  && $('.way-point-animate').length > 2 ) {
                     $(this.element).removeClass('shown') ;
                }else{
                     $(this.element).addClass('shown');
                }
                }, {
                offset: '90%' 
            });
            $('.way-point-animate').waypoint(function(direction) {

                if(  $(this.element).hasClass('shown')  && $('.way-point-animate').length > 2 ) {
                     $(this.element).removeClass('shown') ;
                }else{
                     $(this.element).addClass('shown');
                }
              }, {
                offset: '-90%'
            });
        } 
    }
}

function scrollEvents(){    
    "use strict";

    var scroll_from_top_offset = 10;
    var scroll_from_top = $(document).scrollTop();      
    if(scroll_from_top > scroll_from_top_offset){
        $body.addClass('scrolled');
        if($('header').hasClass('blue-bg')){
            $('header .dark-logo').hide();
            $('header .white-logo').show();
        }
    }else{
        $body.removeClass('scrolled');
        if($('header').hasClass('blue-bg')){
            $('header .white-logo').hide();
            $('header .dark-logo').show();
        }
    }
    $(window).scroll(function(){
        scroll_from_top = $(document).scrollTop();      
        if(scroll_from_top > scroll_from_top_offset){
            $body.addClass('scrolled');
             if($('header').hasClass('blue-bg')){
                $('header .dark-logo').hide();
                $('header .white-logo').show();
            }
        }else{
            $body.removeClass('scrolled'); 
            if($('header').hasClass('blue-bg')){
                $('header .white-logo').hide();
                $('header .dark-logo').show();
            }
        }
    });
    
    $(document).on('scroll', ScrollHandler);
}
function openAjaxModal(href,$mm){

    $m = $mm || $modal;


    $m.removeData('bs.modal');
    $m.empty();
    $m.load(href,function(){
        $m.modal('show');
        callbacks('#'+$m.attr('id'));
    });

}

function equalizeHeight(target){
	$('.'+ target).each(function(){
		$('.'+ target).addClass('autoHeight');
		$('.'+ target).css('min-height','auto');
		if($('.'+ target).parent().hasClass('card')){
			$('.'+ target).css('height','auto');
		}
	});
	
    var min_height = 0;
    setTimeout(function(){
        $('.'+ target).each(function(){
            if($(this).innerHeight() > min_height){
                min_height = $(this).innerHeight();
            }
        });
        if(min_height>0){
            $('.'+ target).css('min-height',min_height);
			if($('.'+ target).parent().hasClass('card')){
				$('.'+ target).css('height',min_height);
			}
        }
		$('.'+ target).each(function(){			 
			$('.'+ target).removeClass('autoHeight');
		});
		
    },500);
	
}


function form_submit_response(target, type, message, r) {
    "use strict";
    var redirect = r || false;
    //alert(message);
    
    
    var $timeout = 0;
    
    if($body.hasClass('modal-open') ){
        $('.modal').modal('hide');
        $timeout = 300; 
    }
    setTimeout(function(){
        var _container = target || '';
        if(type == 'success'){
            var icon = '<i class="fa fa-check-circle" aria-hidden="true"></i>'; 
        }else{
            var icon = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i>';   
        }
        var content = '<div class="alert alert-'+type+'"><span>'+icon+' '+message+'</span></div>'
        $('#responseModal .modal-body').html(content);  
        $body.addClass('dark-backdrop');
        $('#responseModal').modal('show');
        $('#responseModal').on('hidden.bs.modal', function () {
            $('#responseModal .modal-body').empty();
            $body.removeClass('dark-backdrop');
        });
    },$timeout);
    
    setTimeout(function(){
        $('#responseModal').modal('hide');
    },3000);
    
    
    if (redirect) {
        setTimeout(function () {
            window.location.reload();
        }, 2000);
    }
}




function triggerClick(target) {
	$('.'+target).trigger('click');
}

function callbacks(c) {
    var container = c || '';
    ajaxContent(container + ' .ajax-content');
    initWayPoints();
    $(container + ' .callbacks').each(function () {
        if(!$(this).hasClass('callbacks-executed')){
            if(container !=='' || !$(this).hasClass('callbacks-executed')){
            var c = $(this).data();
            for (var i in c) {
                if (i.indexOf('fn') == 0 && c[i] != '') {
                    var fn = c[i];
                    var params = c[ 'params' + i ] || null;

                    $(this).addClass('callbacks-executed');

                    try {
                        if (c[ 'after' + i ] && typeof(window[c[ 'after' + i ]]) === 'function') {

                            var callbackAfter = c[ 'after' + i ];
                            var callbackAfterParams = c[ 'after' + i + 'Params' ] || null;

                            window[ fn ](params, function(){
                                window[callbackAfter](callbackAfterParams);
                            });
                        } else {
                            window[ fn ](params);
                        }
                    } catch (Error) {
                        console.log(Error + ' '+fn);
                    }
                }
            }
        }
        }
    });
}
function ScrollHandler(e) {
    
}

function scroll2position(pos,t) {
    var el = $(pos);
    $('html, body').animate({scrollTop:  el.innerHeight() }, t || 500);
   return false;
}

function more(target) {

    if ($('form[name="' + target + '-nav"] ').hasClass('busy')) {
        return false;
    }

    var c      = $('form[name="' + target + '-nav"] input[name="page"]').val();
    var offset = $('form[name="' + target + '-nav"] input[name="offset"]').val();

    $('form[name="' + target + '-nav"] input[name="page"]').val(Number(c) + 1);
    $('form[name="' + target + '-nav"]').addClass('busy');


    $('.load-more[data-target="'+target+'"]').hide();

    $.ajax({data: $('form[name="' + target + '-nav"]').serialize(), dataType: 'html', success: function (result) {
 
        $('form[name="' + target + '-nav"]').removeClass('busy');
        
       
        $('.' + target + '-list').append(result);          
        callbacks('.' + target + '-list');       

         var updatePages = updateNumPages(target);    
           
          

    }
    });
}

var ajax_contents = [];
function ajaxContent(c){
    $modal = $('#modal');
    var contents = c || '.ajax-content';
    $(contents).each(function () {
        ajax_contents.push(
            {
                'target': $(this),
                'content':$(this).data('ajaxContent')
            }
        );
    });
    loadAjaxContent();
}

function loadAjaxContent(){
    if(ajax_contents.length > 0){
        var target  = ajax_contents[0].target,
            content = ajax_contents[0].content;

        target.addClass('ajax-load-initiated');

        target.load(content,function(){
            var uniq = (Math.random() + '').replace('0.', '');
            target.addClass('ajax-loaded-'+uniq);
            callbacks('.ajax-loaded-'+uniq);
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
        });
    }else{
        $('.ajax-load-initiated').removeClass('ajax-load-initiated');
    }
}



